module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/line-6c4fad9f00eb3796397246b91f4c6b70.png";